<div class="app-header">
  <div class="app-header-logo flex-left">
    <a routerLink="/login" aria-label="Home">
      <img
        src="../../../assets/images/logos/logo-simplify-your-taxes.svg"
        height="84px"
      />
    </a>
  </div>
  <div class="flex-content app-header-content">
    <div *ngIf="this.label != 'Legal Agreement'" class="app-header-title">Create an account</div>
    <div class="app-header-subtitle">
      <mat-icon
        *ngIf="icon.length > 0"
        aria-hidden="false"
        fontIcon="{{ icon }}"
      ></mat-icon>
      <span>{{ label }}</span>
    </div>
  </div>
  <div class="flex-right">
    <a routerLink="/login" class="home-link">
      <mat-icon aria-hidden="true">home</mat-icon>
      <span>Home</span>
    </a>
  </div>
</div>
